var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.empty)?_c('div',{staticClass:"empty-state"},[(_vm.icon)?_c(_vm.icon,{tag:"component"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.emptyText))])],1):_c('div',{staticClass:"page-layout"},[_c('header'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }